import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Grid, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers";

function TimePickerDate(props) {
  return (
    <Grid style={{ width: "100%", height: "100%" }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopTimePicker
          ampm={props.ampm || false}
          defaultValue={props.defaultValue}
          disabled={props.disabled}
          onChangeText={props.onChangeText}
          value={props.value ? props.value : dayjs()}
          onAccept={props.onAccept}
          onChange={props.onChange || function (e) {}}
          renderInput={(params) => (
            <TextField
              fullWidth={true}
              size={props.size ? props.size : " "}
              style={{ width: "100%" }}
              {...params}
              inputProps={{
                ...params.inputProps,
                readOnly: props.readOnly || true,
                placeholder: props.placeholder,
              }}
            />
          )}
        />
      </LocalizationProvider>
    </Grid>
  );
}

export default TimePickerDate;
